import React, { useEffect, useRef } from 'react';
import cn from 'classnames';
import { Tag } from 'components/UI';

import * as styles from './TagsGroup.module.scss';

export default function TagsGroup({
  field,
  className,
  options,
  value,
  onChange,
  name,
  maxLength,
  errorsShakeHub,
}) {
  const tagsGroupRef = useRef(null);
  const selected = value || field?.value;
  const isMultiple = Array.isArray(selected);

  const onSetFocusHandler = ({ detail }) => {
    if (field.name === detail) {
      tagsGroupRef.current.scrollIntoView({ block: 'center' });
    }
  };

  useEffect(() => {
    errorsShakeHub.addEventListener('setFocus', onSetFocusHandler);

    return () => {
      errorsShakeHub.removeEventListener('setFocus', onSetFocusHandler);
    };
  }, [errorsShakeHub, tagsGroupRef.current]);

  const handleOptionClick = clicked => e => {
    e.preventDefault();

    let result = [];

    if (isMultiple) {
      result = selected.some(value => value === clicked.value)
        ? selected.filter(item => item !== clicked.value)
        : [...selected, clicked.value];
    } else {
      result = selected === clicked.value ? '' : clicked.value;
    }

    onChange(result);
  };

  const isOptionActive = option => {
    return isMultiple ? selected.some(value => value === option.value) : selected === option.value;
  };

  return (
    <div ref={tagsGroupRef} className={cn(className, styles.wrapper)} tabIndex={0} name={name}>
      {options.map(option => (
        <Tag
          key={option.value}
          mods={['noclose', 'rounded', isOptionActive(option) && 'active']}
          className={cn(
            styles.tag,
            !isOptionActive(option) && selected.length === maxLength && styles.disabled,
          )}
          onClick={handleOptionClick(option)}
          data-active={isOptionActive(option)}
        >
          {option.content}
        </Tag>
      ))}
    </div>
  );
}
